import {FBM_ORDER_TYPES} from "../../staticData/staticVariables";

/**
 * Checks for what order types are allowed to be created by the current user
 * (used to build props for ChooseOrderFBMCreatePopup and similar popups)
 */
export const FBMCreatePopupMixin = {
  methods: {
    checkCreateConsolidation() {
      if(this._.has(this.currentPermissions, this.PERMISSIONS.ORDER_FBM_CONSOLIDATION)){
        return `/create/${FBM_ORDER_TYPES.FBM_ORDER_CONSOLIDATION.name}`
      }
    },
    checkCreateWarehouse() {
      if(this._.has(this.currentPermissions, this.PERMISSIONS.ORDER_FBM_WAREHOUSE)){
        return `/create/${FBM_ORDER_TYPES.FBM_ORDER_WAREHOUSE.name}`
      }
    },
    checkCreateLabel() {
      if(this._.has(this.currentPermissions, this.PERMISSIONS.ORDER_FBM_LABEL)){
        return `/create/${FBM_ORDER_TYPES.FBM_ORDER_LABEL.name}`
      }
    },
  }
}
